import api from '@/api'
import axios from 'axios'

//获取商品列表
export async function getProducts(params) {
  return api.post('api/services/app/FrontendProduct/SearchKeyWords', params);
}

//获取轮播图
export async function getCarouselConfigs() {
  var paramStr='SkipCount=0';
  paramStr += '&MaxResultCount=10';
  return api.get('/api/services/app/FrontendCarouselConfig/GetCarouselConfigsBySupply?'+paramStr)
}

//获取底部链接
export async function getBottomLinks() {
  var paramStr='SkipCount=0';
  paramStr += '&MaxResultCount=10';
  return api.get('/api/services/app/FrontendBottomLink/GetBottomLinksBySupply?'+paramStr)
}


//获得商品分类
export async function getProductCateTypes() {
  return api.get('/api/services/app/FrontendCategories/GetProductCategorys')
}

//获得商品主分类
export async function getProductMainCateTypes() {
  return api.get('/api/services/app/FrontendCategories/GetProductMainCategorys')
}

//获得商城导航
export async function getNavigations() {
  return api.get('/api/services/app/FrontendNavigation/GetNavigations')
}

//获取分类
export async function getCategorys(data) {
  var param='?1=1';
  if(data&&data.cateId)
  {
    param +='&cateId='+ data.cateId;
  }
  if(data&&data.navigationId)
  {
    param +='&navigationId='+ data.navigationId;
  }
  if(data&&data.productName)
  {
    param +='&productName='+ data.productName;
  }
  return api.get('api/services/app/CommonLookup/GetCategories' + param)
}

//获取品牌
export async function getBrands(data) {
  var param='?1=1';
  if(data&&data.cateId)
  {
    param +='&cateId='+ data.cateId;
  }
  if(data&&data.navigationId)
  {
    param +='&navigationId='+ data.navigationId;
  }
  if(data&&data.brandName)
  {
    param +='&brandName='+ data.brandName;
  }
  if(data&&data.productName)
  {
    param +='&productName='+ data.productName;
  }
  return api.get('api/services/app/CommonLookup/GetBrands'+param)
}


export async function getSettings(data) {
  return api.get('api/services/app/FrontendConfiguration/GetAllSettings')
}

export async function getTitle(data) {
  return api.get('api/services/app/FrontendConfiguration/GetMallTile')
}


export async function getMember() {
  return api.get('api/services/app/FrontendMember/GetMember')
}

export async function getMessages() {
  return api.get('api/services/app/FrontendUserMessage/GetMemberMessages')
}


// WEBPACK FOOTER //
// ./src/api/homePage.js